import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import "./scan-result.scss"
import {Typography} from "@mui/material"
import useScanData from "hooks/useScanData";
import { vendorActions } from "redux/vendorSlice";

export default function ScanResultTableCell ({id, onUpdateScanData}) {
  const dispatch = useDispatch();
  const { scanData } = useScanData(id, true, true)
  const autoSubmittedRef = useRef(false);

  useEffect(() => {
    // Only update if scanData actually exists and has changed
    if (scanData && scanData.id) {
      onUpdateScanData(scanData);
    }
  }, [scanData?.id, scanData?.status, scanData?.scanStage, onUpdateScanData])

  // Auto-submit completed scans ONLY if not viewing certificate details
  useEffect(() => {
    // Only auto-submit from table if we're not on the certificate details page
    const isOnDetailsPage = window.location.pathname.includes('/certificates/' + id);

    if (scanData?.status === "COMPLETED" && scanData?.id && id && !autoSubmittedRef.current && !isOnDetailsPage) {
      autoSubmittedRef.current = true;
      console.log('ScanResultTableCell: Auto-submitting completed scan from list view', { certificateId: id, scanId: scanData.id });

      // Submit the scan result to the certificate
      dispatch(vendorActions.submitScanResultToCertificate({
        certificateData: { id },
        scanData
      })).then((result) => {
        if (result?.payload?.success) {
          console.log('ScanResultTableCell: Auto-submit successful');
        } else {
          console.error('ScanResultTableCell: Auto-submit failed', result);
          autoSubmittedRef.current = false; // Allow retry on failure
        }
      }).catch((error) => {
        console.error('ScanResultTableCell: Auto-submit error', error);
        autoSubmittedRef.current = false; // Allow retry on error
      });
    }

    // Reset flag when scan is no longer COMPLETED
    if (scanData?.status !== "COMPLETED") {
      autoSubmittedRef.current = false;
    }
  }, [scanData?.status, scanData?.id, id, dispatch])
  
  if(scanData?.status === "PENDING") {
    return (
      <Typography
        className="blink"
        sx={{textTransform: "capitalize"}}
      >
        {String(`${scanData.status}${scanData?.scanStage ? ` - ${scanData.scanStage}` : ""}`).toLowerCase()}
      </Typography>
    )
  } else if(scanData?.status === "COMPLETED") {
    return (
      <Typography
        className="blink"
        sx={{textTransform: "capitalize"}}
      >
        Completed - saving result
      </Typography>
    )
  } else if(scanData?.status === "FAILED") {
    return (
      <Typography
        sx={{
          color: "darkred",
          textTransform: "capitalize"
        }}
      >
        {String(scanData.status).toLowerCase()}
      </Typography>
    )
  } else if(scanData?.status === "SUBMITTED") {
    return (
      <Typography
        sx={{
          color: "green",
          textTransform: "capitalize"
        }}
      >
        Saved
      </Typography>
    )
  }
  return null
}
